import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import { makeStyles } from '@material-ui/core';
import './popup.css';

const useStyles = makeStyles(() => ({
  popupModalSmallBtn: {
    '& button': {
      fontSize: '16px',
      lineHeight: '47px',
      height: '47px',
      textAlign: 'center',
      color: '#fff',
      background: '#000',
      fontFamily: 'Conv_AtlasGrotesk-Medium-App',
      textTransform: 'inherit',
      width: 'auto',
      borderRadius: '0',
      padding: '0 42px',
      '&:hover': {
        background: '#000',
        boxShadow: 'none',
      },
    },
  },
}));

const MobileAccessPopup = props => {
  const {
    openPopup,
    setOpenPopup,
    setMobileAccessEnable,
    mobileAccessEnable,
  } = props;
  const classes = useStyles();

  const handleClickUpdateMob = () => {
    setMobileAccessEnable(!mobileAccessEnable);
    setOpenPopup(false);
  };

  const handleCloseMob = () => {
    setMobileAccessEnable(mobileAccessEnable);
    setOpenPopup(false);
  };
  return (
    <div>
      <Dialog
        open={openPopup}
        disableBackdropClick
        onClose={handleCloseMob}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div className="popupModalSmall">
          <div className="popupModalSmallCont">
            <h3>Are you sure you want to disable mobile access?</h3>
            <p>This will stop the user&apos;s mobile access card working.</p>
          </div>
          <div className={`${classes.popupModalSmallBtn} popupModalSmallBtn`}>
            <Button onClick={handleCloseMob} color="primary">
              No, don’t
            </Button>
            <Button onClick={handleClickUpdateMob} color="primary" autoFocus>
              Yes, disable
            </Button>
          </div>
        </div>
      </Dialog>
    </div>
  );
};
export default MobileAccessPopup;
